module.exports = __webpack_public_path__ + "static/media/token-vai.0736a84b.svg";